<template>
  <v-container fluid class="webConGroupItem-management mt-4 px-1">
    <v-row>

      <template>
        <v-row justify="center">
          <v-dialog
              v-model="dialog_upload"
              width="1250px"
          >
            <v-card>

              <UploadManagement
                  id="Conpage_UploadManagement">

              </UploadManagement>

            </v-card>


          </v-dialog>
        </v-row>
      </template>


      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการไฟล์เอกสารชุดกลุ่ม</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + webConGroupItems.length }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="4">

                  <v-select
                      @change="searchData"
                      @blur="changeGroupMaster('s')"
                      v-model="search_data.group_master_id"
                      :items="group_master_combo"
                      item-text="group_master_name_th"
                      item-value="group_master_id"
                      label="ประเภทเอกสาร"
                      clearable=""
                  ></v-select>


                </v-col>


                <v-col class="d-flex" cols="12" sm="4">

                  <v-select
                      @change="searchData"
                      v-model="search_data.group_sub_a_id"
                      :items="group_sub_a_combo_use"
                      :item-text="item => item.group_sub_a_index +' - '+ item.group_sub_a_title_th"
                      item-value="group_sub_a_id"
                      label="ส่วนแสดงผล"
                      clearable=""
                  ></v-select>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                  <v-text-field
                      append-icon="mdi-magnify"
                      class="search"
                      v-model="search"
                      label="ค้นหา (Search)"
                  ></v-text-field>
                </v-col>

              </v-row>


              <!--              <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="ค้นหา (Search)"
                                single-line
                                hide-details
                                class="search"
                            ></v-text-field>-->
            </div>
          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :items-per-page="15"
                :footer-props="{
                'items-per-page-options': [5, 10, 15, 50,-1]
                }"
                :items="webConGroupItems"
                :search="search"
                :options="options">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>
                </template>


              </template>

              <template v-slot:item.group_item_h_file="{ item }">

                <v-avatar tile v-if="item.status_link =='Y'">
                  <img
                      :src="baseURLStorage+'/icon_extensions/'+'File_Share.svg'"
                      :alt="item.group_item_title_th"
                  >
                </v-avatar>
                <v-avatar tile v-else>
                  <img
                      :src="baseURLStorage+'/icon_extensions/'+'File_Cloud.svg'"
                      :alt="item.group_item_title_th"
                  >
                </v-avatar>

              </template>


              <template v-slot:item.switch_lang="{ item }">
                <v-btn
                    fab
                    x-small
                    depressed
                    color=""
                >TH
                </v-btn>
                <v-btn v-if="item.switch_lang=='Y'"
                       fab
                       x-small
                       depressed
                       color=""
                >EN
                </v-btn>

              </template>

              <template v-slot:item.group_item_title_th="{ item }">
                <a :href="baseURLStorage+item.group_item_h_file" target="_blank" v-if="item.status_link =='Y'">
                  <span>{{ item.group_item_title_th }}</span>
                </a>

                <a :href="item.group_item_h_url" target="_blank" v-else>
                  <span>{{ item.group_item_title_th }}</span>
                </a>


              </template>


              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>



              </template>


              <template v-slot:item.api="{ item }">
                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>
                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2">
                  <v-text-field
                      v-if="state=='addForm'"
                      v-model="editForm.order_seq"
                      label="ลำดับ"
                      required
                      disabled

                  ></v-text-field>

                  <v-text-field
                      v-else
                      v-model="editForm.order_seq"
                      :rules="editForm.textReqRules.concat(editForm.orderRules)"
                      label="ลำดับ"
                      required

                  ></v-text-field>

                </v-col>

                <v-col class="d-flex" cols="12" sm="3">
                  <v-text-field
                      v-model="editForm.group_item_index"
                      label="ลำดับหัวข้อ"
                      hint="(ตัวเลข ตัวอักษร)"
                      persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex" cols="12" sm="3">

                  <v-text-field
                      v-model="editForm.group_item_year"
                      label="ปี"
                      hint="ปี พ.ศ."
                      persistent-hint

                  ></v-text-field>
                </v-col>



                <v-col class="d-flex" cols="12" sm="3">

                  <v-switch
                      v-model="editForm.switch_lang"
                      inset
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="เพิ่มเนื้อหาภาษา [EN]"
                      required
                  ></v-switch>


                </v-col>

              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="4">

                  <v-select
                      @change="changeGroupMaster('e')"
                      v-model="editForm.group_master_id"
                      :rules="editForm.textReqRules"
                      :items="group_master_combo"
                      :item-text="item => item.group_master_name_th +' - '+ item.group_master_title_th"
                      item-value="group_master_id"
                      label="ประเภทเอกสาร"
                      required
                      clearable=""
                  ></v-select>



                </v-col>

                <v-col class="d-flex" cols="12" sm="4">

                  <v-select
                      @change="changeGroupSubA('e')"
                      v-model="editForm.group_sub_a_id"
                      :rules="editForm.multipleReqRules"
                      :items="group_sub_a_combo_use"
                      :item-text="item => item.group_sub_a_index +' - '+ item.group_sub_a_title_th"
                      item-value="group_sub_a_id"
                      label="ประเภทรอง"
                      required
                      clearable=""
                  ></v-select>

                </v-col>

                <v-col class="d-flex" cols="12" sm="4">

                  <v-select
                      v-model="editForm.group_sub_b_id"
                      :rules="editForm.multipleReqRules"
                      :items="group_sub_b_combo_use"
                      item-text="group_sub_b_title_th"
                      item-value="group_sub_b_id"
                      label="ประเภทย่อย"
                      required
                      clearable=""
                  ></v-select>

                </v-col>

              </v-row>

              <v-row align="center">



<!--                <v-col class="d-flex" cols="12" sm="4">
                  <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="dateFormatted"
                          label="วันที่เอกสาร"
                          hint="วัน/เดือน/พ.ศ."
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date"
                        :first-day-of-week="1"
                        locale="th"
                        @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>-->


              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                      v-model="editForm.group_item_title_th"
                      :rules="editForm.textReqRules"
                      label="หัวข้อไฟล์/ชื่อเรื่อง (TH)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12" v-if="editForm.switch_lang=='Y'">
                  <v-text-field
                      v-model="editForm.group_item_title_en"
                      :rules="editForm.textReqRules"
                      label="หัวข้อไฟล์/ชื่อเรื่อง (EN)"
                      required
                  ></v-text-field>
                </v-col>

              </v-row>
              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2">

                  <v-switch
                      v-model="editForm.status_link"
                      inset
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="อัพโหลดไฟล์ | URL"
                      required
                  ></v-switch>

                </v-col>

                <v-col class="d-flex" cols="12" sm="10" v-if="state=='addForm'">
                  <v-file-input
                      v-if="editForm.status_link=='Y'"
                      v-model="editForm.avatarFileFi"
                      show-size
                      chips
                      :rules="editForm.textReqRules.concat(editForm.fileRules)"
                      placeholder="อัพโหลดไฟล์"
                      prepend-icon="mdi-file"
                      label="อัพโหลดไฟล์"
                  ></v-file-input>

                  <v-text-field
                      v-if="editForm.status_link=='N'"
                      v-model="editForm.group_item_h_url"
                      :rules="editForm.textReqRules"
                      label="URL ของไฟล์"
                      required
                  ></v-text-field>

                </v-col>
                <v-col class="d-flex" cols="12" sm="10" v-if="state=='editForm'">


                  <div class="text-center" v-if="editForm.status_link=='Y' && !editForm.avatarFileFiOld==false">
                    <v-chip
                        link
                        class="ma-4"
                        color="default"
                    >
                      <v-icon left>mdi-file</v-icon>
                      <a :href="baseURLStorage+editForm.avatarFileFiOld" target="_blank">
                        ไฟล์อัพโหลดเดิม </a>
                    </v-chip>
                  </div>


                  <v-file-input
                      v-if="editForm.status_link=='Y'"
                      v-model="editForm.avatarFileFi"
                      show-size
                      chips
                      :rules="editForm.fileRules"
                      placeholder="อัพโหลดไฟล์ใหม่"
                      prepend-icon="mdi-file"
                      label="อัพโหลดไฟล์ใหม่"
                  ></v-file-input>


                  <v-text-field
                      v-if="editForm.status_link=='N'"
                      v-model="editForm.group_item_h_url"
                      :rules="editForm.textReqRules"
                      label="URL ของไฟล์"
                      required
                  ></v-text-field>

                </v-col>


              </v-row>


              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="2">

                  <v-switch
                      v-model="editForm.active"
                      inset
                      color="success"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ใช้งาน"
                      required
                  ></v-switch>


                </v-col>


              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
import Editor from '@tinymce/tinymce-vue';

import UploadManagement from '@/pages/WebContent/UploadManagement/UploadManagement';
import axios from "axios";

export default {
  name: 'ConGroupItemManagement',
  data() {
    return {
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      state: 'index',
      tiny: config.tiny,
      baseURLApi: config.baseURLApi,
      baseURLStorage: config.baseURLStorage,
      snackbar: null,
      dialog_upload: false,
      search: '',
      search_data: {
        group_master_id: "",
        group_sub_a_id: "",
        group_sub_b_id: "",
      },
      options: {
        sortBy: ['group_item_id'],
        sortDesc: [true]
      },
      selected: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'group_item_id',
        },
        {
          text: 'ไฟล์เอกสาร', value: 'group_item_h_file',
        },
        {text: 'ปี พ.ศ.', value: 'group_item_year'},
        {text: 'หลายภาษา', value: 'switch_lang'},
        {text: 'หัวข้อไฟล์/ชื่อเรื่อง', value: 'group_item_title_th'},
        {text: 'ใช้งาน', value: 'active'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],

      group_master_combo: [],
      group_sub_a_combo: [],
      group_sub_b_combo: [],

      group_sub_a_combo_use: [],
      group_sub_b_combo_use: [],

      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {},
    }
  },
  components: {
    'editor': Editor, // <- Important part
    UploadManagement
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('web_con_group_items', ['webConGroupItems', "isReceiving", "isDeleting", "idToDelete", "webConGroupItemMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },



  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    webConGroupItemMessage() {

      if (this.webConGroupItemMessage !== '') {
        this.notification = this.webConGroupItemMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    },


  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getWebConGroupItemsRequest(this.search_data);
    this.getDcParamCombobox();
    this.resetValue();
  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('web_con_group_items',
        [
          "getWebConGroupItemsRequest",
          "deleteWebConGroupItemRequest",
          "updateWebConGroupItemRequest",
          "createWebConGroupItemRequest"
        ]
    ),
    resetValue() {

      this.editForm = {
        valid: true,
        orderRules: validateRules.orderRules,
        numRules: validateRules.numRules,
        textReqRules: validateRules.textReqRules,
        multipleReqRules: validateRules.multipleReqRules,
        fileRules: validateRules.fileSingleRules(100),
        group_item_id: null,
        group_sub_a_id: '',
        group_sub_b_id: '',
        group_master_id: '',
        group_item_index: '',
        group_item_year: '',
        group_item_title_th: '',
        group_item_title_en: '',
        group_item_content_th: '',
        group_item_content_en: '',
        switch_lang: 'N',
        status_link: 'Y',
        active: 'N',
        avatarFileFi: null,
        avatarFileFiOld: null,
        group_item_h_image_th:'',
        group_item_h_image_en:'',
        order_seq:'AUTO'

      }
    },
    async getDcParamCombobox() {


      try {

        await axios.post(config.baseURLApi + '/combo_dc_group_master/' + 'green-unit', '', {
          headers: {},
        }).then(res => {
          this.group_master_combo = res.data;

        });

      } catch (e) {
        this.showSnackbar(e);
      }


      try {

        await axios.post(config.baseURLApi + '/combo_dc_group_sub_a/all' , '', {
          headers: {},
        }).then(res => {
          this.group_sub_a_combo = res.data;

        });

      } catch (e) {
        this.showSnackbar(e);
      }


      try {

        await axios.post(config.baseURLApi + '/combo_dc_group_sub_b/all' , '', {
          headers: {},
        }).then(res => {
          this.group_sub_b_combo = res.data;

        });

      } catch (e) {
        this.showSnackbar(e);
      }



    },
    removeTag(item) {

      this.editForm.doc_tag.splice(this.editForm.doc_tag.indexOf(item), 1)
    },


    async addItem() {

      this.editedIndex = -1 //index = -1 add
      this.resetValue();
      this.editForm.group_master_id = '';
      await this.changeGroupMaster('e');
      await this.changeGroupSubA('e');
      this.editForm.active = 'Y';
      this.editForm.group_item_index = '-'
      const [year] = this.date.split('-')
      this.editForm.group_item_year = year * 1 + 543
      this.editForm.status_link = 'Y';
      this.editForm.group_item_id = 'AUTO';
      this.editForm.order_seq = 'AUTO';
      this.editForm.group_item_h_url = '#';
      this.state = 'addForm';

    },
    async editItem(item) {



      console.log(item)

      // check |null undefined 0 -0 NaN '' false| !X Xis variable return true if null !!x is notnull
      this.resetValue();
      this.editedIndex = this.webConGroupItems.indexOf(item) //index ของ row ที่จะแก้ไข

      this.editForm.group_item_id = item.group_item_id;
      this.editForm.group_master_id = item.group_master_id;
      await this.changeGroupMaster('e');
      this.editForm.group_sub_a_id = item.group_sub_a_id;
      await this.changeGroupSubA('e');
      this.editForm.group_sub_b_id = item.group_sub_b_id;
      this.editForm.group_item_index = item.group_item_index;
      this.editForm.group_item_year = item.group_item_year;
      // this.editForm.group_item_h_image_th = item.group_item_h_image_th;
      // this.editForm.group_item_h_image_en = item.group_item_h_image_en;
      this.editForm.group_item_title_th = item.group_item_title_th;
      this.editForm.group_item_title_en = item.group_item_title_en;
      this.editForm.status_link = item.status_link;
      this.editForm.group_item_h_url = item.group_item_h_url;
      this.editForm.avatarFileFiOld = item.group_item_h_file;
      // this.editForm.group_item_content_th = item.group_item_content_th;
      // this.editForm.group_item_content_en = item.group_item_content_en;
      this.editForm.switch_lang = item.switch_lang;
      this.editForm.order_seq = item.order_seq * 1;
      this.editForm.active = item.active;

      // this.editForm = Object.assign({}, item) //ถ้าใช้ validate not work!!
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteWebConGroupItemRequest({group_item_id: item.group_item_id})

    },
    close() {

      if (this.errorMessage == false || this.webConGroupItemMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }
    },
    save() {

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.webConGroupItems[this.editedIndex], this.editForm)
            :
            this.updateWebConGroupItemRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.webConGroupItems.push(this.editForm)
            :
            this.createWebConGroupItemRequest(this.editForm)
      }


    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    reset() {
      this.$refs.form.reset()
    },
    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },
    showUploads() {
      this.dialog_upload = true;
    },
    changeGroupMaster(v_form) {
      console.log('Master')
      var group_master_id = null;
      group_master_id = v_form == 'e' ? this.editForm.group_master_id : this.search_data.group_master_id;
      console.log(this.editForm)
      if (!group_master_id == false) { //flase is not nall
        this.editForm.group_sub_a_id = null
        this.editForm.group_sub_b_id = null
        try {
          this.group_sub_a_combo_use = this.group_sub_a_combo.filter(item => item.group_master_id === group_master_id)
        } catch (e) {
          console.log(e)
          this.group_sub_a_combo_use = []
          this.group_sub_b_combo_use = []
        }

      } else {
        this.editForm.group_sub_a_id = null
        this.editForm.group_sub_b_id = null
        this.group_sub_a_combo_use = []
        this.group_sub_b_combo_use = []
      }
    },
    changeGroupSubA(v_form) {
      console.log('SubA')
      var group_sub_a_id = null;
      group_sub_a_id = v_form == 'e' ? this.editForm.group_sub_a_id : this.search_data.group_sub_a_id;
      console.log(this.editForm)
      if (!group_sub_a_id == false) { //flase is not nall
        this.editForm.group_sub_b_id = null
        try {
          this.group_sub_b_combo_use = this.group_sub_b_combo.filter(item => item.group_sub_a_id === group_sub_a_id)
        } catch (e) {
          console.log(e)
          this.group_sub_b_combo_use = []
        }

      } else {
        this.editForm.group_sub_b_id = null
        this.group_sub_b_combo_use = []
      }
    },

    searchData() {
      this.getWebConGroupItemsRequest(this.search_data);
    },

    async beforeMount() {
    },

  },
}
</script>

<style src="./ConGroupItemManagement.scss" lang="scss"/>
